module.exports = __webpack_public_path__ + "img/img_24.35df87c9.svg";